import React from 'react';
import { TableCell as MuiTableCell, Typography } from '@mui/material';
import { DataTableColumn } from '../types';
import { useDataTableTheme } from '../theme';

interface TableHeaderCellProps {
  column: DataTableColumn;
}

/**
 * 테이블 헤더 셀 컴포넌트
 */
export function TableHeaderCell({ column }: TableHeaderCellProps) {
  const { getCellSx, tokens } = useDataTableTheme();
  const align = column.align || 'left';

  return (
    <MuiTableCell
      align={align}
      sx={{
        ...getCellSx(),
        ...(column.width && {
          width: column.width,
          minWidth: column.width,
          maxWidth: column.width,
        }),
      }}
    >
      <Typography
        variant="subtitle2"
        fontWeight={tokens.header.text.fontWeight}
        sx={{
          color: tokens.header.text.default,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {column.label}
      </Typography>
    </MuiTableCell>
  );
}
